function check_korb(){
    var valid = true;
    var ids_korb;
    var preis_total = 0;
    ids_korb_str = $("#js-ids_korb").val();
    ids_korb = ids_korb_str.split(',');
    for(m = 0; m < ids_korb.length; m++){
        id_korb = ids_korb[m];
        if(hx.is_numeric(document.f.elements['korbpos' + id_korb].value) == false || document.f.elements['korbpos' + id_korb].value == ''){
            displayErrorBox(cpText.shop_form_nicht_numerisch + " " + cpText.shop_korb_anzahl);
            document.f.elements['korbpos' + id_korb].focus();
            document.f.elements['korbpos' + id_korb].select();
            valid = false;
        }else if(parseFloat(document.f.elements['korbpos' + id_korb].value) < parseInt(document.f.elements['mindestmenge' + id_korb].value, 10)){
            displayErrorBox(cpText.prod_mindestmenge_ist + " " + parseInt(document.f.elements['mindestmenge' + id_korb].value, 10));
            document.f.elements['korbpos' + id_korb].focus();
            document.f.elements['korbpos' + id_korb].select();
            valid = false;
        }else{
            preis_total = preis_total + (parseInt(document.f.elements['korbpos' + id_korb].value) * parseInt(document.f.elements['prodpreis' + id_korb].value));
        }
    }
    return valid;
}
